export const darkSeeMoreButton = {
  id: 'square-panel-see-more-elements-link-text',
  styles: {
    classes: ['h3', 'col'],
  },
};
